import { useRef } from 'react';
import { AUTH_LIST } from '@portalCommon/constants';

import classnames from 'classnames/bind';

import { OptimizedImg } from '@commonPackage/components';
import styles from './index.module.less';

const cx = classnames.bind(styles);

export const AuthBlock = () => {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <section className={cx('auth-block')} ref={ref}>
      <section className={cx('auth-block-main')}>
        {AUTH_LIST.map(item => (
          <dl key={item.imgSrc}>
            <dt>
              <OptimizedImg loading="lazy" src={item.imgSrc} alt={item.text} />
            </dt>
            <dd>{item.text}</dd>
          </dl>
        ))}
      </section>
    </section>
  );
};
